<app-modal *ngIf="vo$ | async; let vo">
	<div modal-body class="app-entity-action-popup">
		<div class="app-entity-action-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span i18n="@@entity.action.popup.concernedElement">
					concerned Element
				</span>
				<span class="app-entity-action-popup__element-label">
					{{ vo.element }}
				</span>
			</ng-container>
			<ng-container *ngIf="vo.isMultipleElement">
				<span i18n="@@entity.action.popup.concernedElements">
					concerned Elements
				</span>
				<div class="app-entity-action-popup__element-label">
					{{ vo.entityId.length }}
					<span i18n="@@entity.action.popup.entities">entities</span>
				</div>
			</ng-container>
		</div>
		<ng-container [ngSwitch]="vo.action">
			<div
				*ngSwitchCase="EntityAction.Delete"
				class="app-entity-action-popup__delete">
				<span
					*ngIf="vo.isMultipleElement"
					class="app-entity-action-popup__description"
					i18n="@@entity.action.popup.delete.multiple.description">
					deletion request
				</span>
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-entity-action-popup__description"
					i18n="@@entity.action.popup.delete.description">
					deletion request
				</span>

				<div class="app-entity-action-popup__delete-info">
					<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
					<span
						*ngIf="vo.isMultipleElement"
						class="app-entity-action-popup__message"
						i18n="@@entity.action.popup.delete.multiple.info">
						deletion info
					</span>
					<span
						*ngIf="!vo.isMultipleElement"
						class="app-entity-action-popup__message"
						i18n="@@entity.action.popup.delete.info">
						deletion info
					</span>
				</div>
				<div class="app-entity-action-popup__checkbox">
					<mat-checkbox
						id="{{ cmpId }}-confirm-checkbox"
						color="primary"
						[(ngModel)]="confirmDeletion">
						<span i18n="@@entity.action.popup.delete.confirm">
							confirm delete
						</span>
					</mat-checkbox>
				</div>
			</div>
			<div
				*ngSwitchCase="EntityAction.Persist"
				class="app-entity-action-popup__persist">
				<span
					*ngIf="vo.isMultipleElement"
					class="app-entity-action-popup__description"
					i18n="@@entity.action.popup.persist.multiple.description">
					Persist
				</span>
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-entity-action-popup__description"
					i18n="@@entity.action.popup.persist.description">
					Persist
				</span>

				<div class="app-entity-action-popup__persist-info">
					<mat-icon [svgIcon]="DcIcons.Info"></mat-icon>
					<span
						*ngIf="vo.isMultipleElement"
						class="app-entity-action-popup__message"
						i18n="@@entity.action.popup.persist.multiple.info">
						persistence info
					</span>
					<span
						*ngIf="!vo.isMultipleElement"
						class="app-entity-action-popup__message"
						i18n="@@entity.action.popup.persist.info">
						persistence info
					</span>
				</div>
			</div>
			<div
				*ngSwitchCase="EntityAction.Repersist"
				class="app-entity-action-popup__repersist">
				<span
					class="app-entity-action-popup__description"
					i18n="@@entity.action.popup.repersist.description">
					Persist
				</span>
			</div>
			<div
				*ngSwitchCase="EntityAction.Depersist"
				class="app-entity-action-popup__depersist">
				<span
					*ngIf="vo.isMultipleElement"
					class="app-entity-action-popup__description"
					i18n="@@entity.action.popup.depersist.multiple.description">
					Persist
				</span>
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-entity-action-popup__description"
					i18n="@@entity.action.popup.depersist.description">
					Persist
				</span>
			</div>
			<div
				*ngSwitchCase="EntityAction.CreateDatablock"
				class="app-entity-action-popup__repersist">
				<span
					class="app-entity-action-popup__description"
					i18n="@@entity.action.popup.createDatablock.multiple.description">
					Persist
				</span>
			</div>
		</ng-container>
	</div>

	<div modal-footer class="app-entity-action-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="EntityAction.Delete"
				id="{{ cmpId }}-delete-btn"
				class="app-entity-action-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirmDeletion || vo.isActionInProgress"
				(click)="confirmAction()"
				mat-raised-button>
				<mat-icon *ngIf="vo.isActionInProgress">
					<mat-spinner color="accent" [diameter]="20"></mat-spinner>
				</mat-icon>
				<mat-icon
					*ngIf="!vo.isActionInProgress"
					[svgIcon]="DcIcons.Delete"></mat-icon>
				<span i18n="@@entity.action.popup.delete.btn">delete</span>
			</button>
			<button
				*ngSwitchCase="EntityAction.Persist"
				id="{{ cmpId }}-persist-btn"
				class="app-entity-action-popup__footer__btn"
				[color]="'primary'"
				[disabled]="vo.isActionInProgress"
				(click)="confirmAction()"
				mat-raised-button>
				<mat-icon *ngIf="vo.isActionInProgress">
					<mat-spinner color="accent" [diameter]="20"></mat-spinner>
				</mat-icon>
				<span i18n="@@entity.action.popup.persist.btn">delete</span>
			</button>
			<button
				*ngSwitchCase="EntityAction.Repersist"
				id="{{ cmpId }}-repersist-btn"
				class="app-entity-action-popup__footer__btn"
				[color]="'primary'"
				[disabled]="vo.isActionInProgress"
				(click)="confirmAction()"
				mat-raised-button>
				<mat-icon *ngIf="vo.isActionInProgress">
					<mat-spinner color="accent" [diameter]="20"></mat-spinner>
				</mat-icon>
				<span i18n="@@entity.action.popup.repersist.btn">repersist</span>
			</button>
			<button
				*ngSwitchCase="EntityAction.Depersist"
				id="{{ cmpId }}-depersist-btn"
				class="app-entity-action-popup__footer__btn"
				[disabled]="vo.isActionInProgress"
				(click)="confirmAction()"
				mat-raised-button>
				<mat-icon *ngIf="vo.isActionInProgress">
					<mat-spinner color="accent" [diameter]="20"></mat-spinner>
				</mat-icon>
				<span i18n="@@entity.action.popup.depersist.btn">depersist</span>
			</button>
			<button
				*ngSwitchCase="EntityAction.CreateDatablock"
				id="{{ cmpId }}-create-db-btn"
				class="app-entity-action-popup__footer__btn"
				[disabled]="vo.isActionInProgress"
				(click)="confirmAction()"
				mat-raised-button>
				<mat-icon *ngIf="vo.isActionInProgress">
					<mat-spinner color="accent" [diameter]="20"></mat-spinner>
				</mat-icon>
				<span i18n="@@entity.action.popup.createDatablock.btn">create db</span>
			</button>
		</ng-container>
	</div>
</app-modal>
